import { z } from 'zod';
import { uuid } from './common.js';
/** Dev-only "Dev login as…" (FR-AUTH-8; `AUTH_DEV_LOGIN=true` and not production). */
export const devLoginSchema = z.object({ userId: uuid });
/**
 * Why a sign-in was refused (FR-AUTH-2..5). The API redirects to `/login?error=<code>`; the
 * login page shows the matching message. Codes never reveal more than the user already knows.
 */
export const AUTH_ERROR_CODES = [
    'email_unverified',
    'not_registered',
    'account_disabled',
    'exited',
    'sub_mismatch',
    'google_unavailable',
    'sign_in_failed',
];
export const AUTH_ERROR_MESSAGES = {
    email_unverified: "Your Google account email isn't verified. Verify it with Google and try again.",
    not_registered: "Your Google account isn't registered in ThriveHRM. Contact HR.",
    account_disabled: 'Your ThriveHRM account is disabled. Contact HR.',
    exited: 'Your access ended after your last working day. Contact HR if this is wrong.',
    sub_mismatch: 'This email is linked to a different Google account. Contact an administrator to reset it.',
    google_unavailable: "Google sign-in isn't available right now. Try again later.",
    sign_in_failed: "Sign-in didn't complete. Please try again.",
};
export function isAuthErrorCode(value) {
    return typeof value === 'string' && AUTH_ERROR_CODES.includes(value);
}
/** `GET /auth/me` — the signed-in user (ARCHITECTURE §4 step 5, SRS §7). */
export const meResponseSchema = z.object({
    userId: uuid,
    name: z.string(),
    email: z.string(),
    /** Role codes held (`EMPLOYEE`, `HR`, `ADMIN`, or roles added by later modules). */
    roles: z.array(z.string()),
    /** Effective permissions — the UI only hides what the user cannot use; the API decides. */
    permissions: z.array(z.string()),
    /** Has at least one current direct report (grants `team.read`). */
    hasReports: z.boolean(),
    employee: z.object({ id: uuid, empCode: z.number().int(), fullName: z.string() }).nullable(),
});
/** `GET /auth/dev/accounts` — accounts offered by "Dev login as…" (FR-AUTH-8). */
export const devLoginAccountsResponseSchema = z.object({
    items: z.array(z.object({
        userId: uuid,
        name: z.string(),
        email: z.string(),
        empCode: z.number().int(),
        roles: z.array(z.string()),
    })),
});
//# sourceMappingURL=auth.js.map